module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Medium.woff2
// module id = 1573
// module chunks = 57